var Config = {
    appName:'chuhai',//项目名称
    version:'1.7.3',//项目版本
  }
  
  module.exports = Config
  